<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="600px"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
    light
  >
    <v-card>
      <v-toolbar max-height="56" elevation="0" class="transparent">
        <v-toolbar-title>{{ $t("theBet") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: auto" class="pa-2 grey darken-3">
        <BetCard />
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <!-- <v-btn text @click="dialog = false">Fechar</v-btn> -->
        <v-btn
          depressed
          class="success"
          :href="whatsappUrl"
          target="_blank"
          @click="$gtag.share('Whatsapp', 'id_bet', bet.id)"
        >
          &nbsp;WhatsApp&nbsp;
          <v-icon right>mdi-share</v-icon>
        </v-btn>

        <v-btn depressed @click="shareBet()" color="red" style="color: white">
          <v-icon left class="ml-2">mdi-download</v-icon>
          <span v-if="!$vuetify.breakpoint.smAndDown"
            >&nbsp;{{ $t("downloadPDF") }}&nbsp;</span
          >
        </v-btn>

        <v-btn
          depressed
          :disabled="disabled_print"
          @click="printBet(), (disabled_print = true)"
          color="info"
        >
          <v-icon left class="ml-2">mdi-printer</v-icon>
          <span v-if="!$vuetify.breakpoint.smAndDown"
            >&nbsp;{{ $t("toPrint") }}&nbsp;</span
          >
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BetCard from "@/components/agent/Backoffice/bet/BetCard";
export default {
  name: "bet-dialog",
  components: {
    BetCard,
  },
  data: () => ({
    dialog: false,

    // Uso do disabled:
    // Força o usuário a fechar e abrir novamente
    // a dialog para imprimir, evitando parcialmente
    // a impressão novamente da pule com Qrcode.
    disabled_print: false,
    isApple: false,
  }),
  mounted() {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      this.isApple = true;
    }
  },
  computed: {
    betAgentDialog() {
      return this.$store.state.betAgentDialog;
    },
    // Bet
    bet() {
      return this.$store.state.betCard;
    },
    whatsappUrl() {
      var operatorUrl = this.$store.state.operators.url;
      var msg = `https://api.whatsapp.com/send?text=Aposta%20validada:%20${this.bet.id}.%20${operatorUrl}home/conferencia/${this.bet.id}`;
      return msg;
    },
  },
  watch: {
    betAgentDialog() {
      this.dialog = true;
    },
    dialog() {
      // reset:
      this.$store.commit("setBetAgentDialog", false);
      this.$store.commit("setShareBet", false);
      this.disabled_print = false;
    },
  },
  methods: {
    printBet: async function () {
      // no ato de imprimir é obrigatório setar 1 no printed
      // do endpoint 'agent/bets/getBetAgent'
      await this.$bet.getBetAgent(this.$store.state.betCard.id, 1);
      this.$printBet(); // Plugin-print.js
    },
    shareBet: async function () {
      this.$store.commit("setShareBet", true);
      await this.$bet.getBetAgent(this.$store.state.betCard.id, 1);
      this.$shareBet(); // Plugin-print.js
    },
  },
};
</script>
